import { Interweave } from 'interweave';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import {
  BASE_URL,
  GET_CONTENTS_BY_MENU_ID,
  GET_IMAGE_BY_MENU_ID,
} from '../../constant/constants';

const settings = {
  dots: true,
  arrows: false,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    { breakpoint: 1500, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

function items(obj) {
  const content = [];
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const contentItem = { [key]: obj[key] };
      content.push(contentItem);
    }
  }
  return content;
}

const OurBlogs = (props) => {
  const [contents, setContents] = useState('');
  const [contentsImage, setContentsImage] = useState('');

  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const imageResponse = await fetch(
          `${GET_IMAGE_BY_MENU_ID}/${id || props.id}`
        );
        const imageData = await imageResponse.json();
        setContentsImage(imageData.content_images);
        console.log('imagesContent', imageData);

        const contentResponse = await fetch(
          `${GET_CONTENTS_BY_MENU_ID}/${id || props.id}`
        );
        const contentData = await contentResponse.json();
        setContents(contentData.menu_contents);
        console.log('allmenucontent', contentData.menu_contents);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id, props.id]);

  const newContents = items(contents);

  return (
    <section className='wpo-features-section-s6 section-padding'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-lg-6'>
            <div className='wpo-section-title'>
              <span>our</span>
              <h2>Latest Blogs</h2>
            </div>
          </div>
        </div>
        <div className='row'>
          <Slider {...settings}>
            {newContents.map((service, index) => {
              const [contentKey, contentValue] = Object.entries(service)[0];

              if (
                contentKey === 'About' ||
                contentKey === 'Partner' ||
                contentKey === 'Our Services' ||
                contentKey === 'Companies' ||
                contentKey === 'Featured Work'
              ) {
                return null;
              }

              return (
                <div
                  className='col col-xl-4 col-lg-4 col-sm-6 col-12 p-3'
                  key={index}>
                  <div
                    className='wpo-features-item p-0'
                    style={{ borderRadius: '20px' }}>
                    <div>
                      <div>
                        {Object.entries(contentsImage ? contentsImage : {}).map(
                          ([key, value]) =>
                            key === contentKey ? (
                              <img
                                style={{
                                  borderRadius: '20px',
                                  display: 'block',
                                  width: '100%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                  height:
                                    window.innerWidth < 768 ? '200px' : '400px',
                                }}
                                src={`${BASE_URL}/media/${value}`}
                                alt=''
                              />
                            ) : null
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        padding: '20px 40px',
                        minHeight: window.innerWidth < 768 ? '400px' : '300px',
                      }}>
                      <Interweave
                        allowAttributes
                        allowElements
                        disableLineBreaks={true}
                        content={`${contentValue.slice(0, 300)}   ...see more`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default OurBlogs;
